<div class="nav-container {{ navClass ? navClass : '' }}" [class.nav--open]="isOpen$ | async">
  <ng-container *ngIf="showBackdrop">
    <div class="nav__backdrop"></div>
  </ng-container>
  <nav class="nav nav--{{ name }}">
    <air-link-list [linkLists]="navigationItems" [userEventSource]="userEventSource"></air-link-list>
  </nav>
</div>
